export const CAMPAIGN_PLAN_TYPE_SCREEN_OWNER = "ScreenOwnerCampaign";

export const CREATE_CAMPAIGN_FOR_SCREEN_OWNER_REQUEST =
  "CREATE_CAMPAIGN_FOR_SCREEN_OWNER_REQUEST";
export const CREATE_CAMPAIGN_FOR_SCREEN_OWNER_SUCCESS =
  "CREATE_CAMPAIGN_FOR_SCREEN_OWNER_SUCCESS";
export const CREATE_CAMPAIGN_FOR_SCREEN_OWNER_FAIL =
  "CREATE_CAMPAIGN_FOR_SCREEN_OWNER_FAIL";
export const CREATE_CAMPAIGN_FOR_SCREEN_OWNER_RESET =
  "CREATE_CAMPAIGN_FOR_SCREEN_OWNER_RESET";

export const EDIT_CAMPAIGN_FOR_SCREEN_OWNER_REQUEST =
  "EDIT_CAMPAIGN_FOR_SCREEN_OWNER_REQUEST";
export const EDIT_CAMPAIGN_FOR_SCREEN_OWNER_SUCCESS =
  "EDIT_CAMPAIGN_FOR_SCREEN_OWNER_SUCCESS";
export const EDIT_CAMPAIGN_FOR_SCREEN_OWNER_FAIL =
  "EDIT_CAMPAIGN_FOR_SCREEN_OWNER_FAIL";
export const EDIT_CAMPAIGN_FOR_SCREEN_OWNER_RESET =
  "EDIT_CAMPAIGN_FOR_SCREEN_OWNER_RESET";

export const GET_SCREENS_CAMPAIGN_CREATIONS_FOR_SCREEN_OWNER_REQUEST =
  "GET_SCREENS_CAMPAIGN_CREATIONS_FOR_SCREEN_OWNER_REQUEST";
export const GET_SCREENS_CAMPAIGN_CREATIONS_FOR_SCREEN_OWNER_SUCCESS =
  "GET_SCREENS_CAMPAIGN_CREATIONS_FOR_SCREEN_OWNER_SUCCESS";
export const GET_SCREENS_CAMPAIGN_CREATIONS_FOR_SCREEN_OWNER_FAIL =
  "GET_SCREENS_CAMPAIGN_CREATIONS_FOR_SCREEN_OWNER_FAIL";

export const GET_SCREEN_DATA_UPLOAD_CREATIVE_REQUEST =
  "GET_SCREEN_DATA_UPLOAD_CREATIVE_REQUEST";
export const GET_SCREEN_DATA_UPLOAD_CREATIVE_SUCCESS =
  "GET_SCREEN_DATA_UPLOAD_CREATIVE_SUCCESS";
export const GET_SCREEN_DATA_UPLOAD_CREATIVE_FAIL =
  "GET_SCREEN_DATA_UPLOAD_CREATIVE_FAIL";

export const GET_ALL_CAMPAIGNS_DATA_REQUEST = "GET_ALL_CAMPAIGNS_DATA_REQUEST";
export const GET_ALL_CAMPAIGNS_DATA_SUCCESS = "GET_ALL_CAMPAIGNS_DATA_SUCCESS";
export const GET_ALL_CAMPAIGNS_DATA_FAIL = "GET_ALL_CAMPAIGNS_DATA_FAIL";

export const GET_CAMPAIGN_DATA_REQUEST = "GET_CAMPAIGN_DATA_REQUEST";
export const GET_CAMPAIGN_DATA_SUCCESS = "GET_CAMPAIGN_DATA_SUCCESS";
export const GET_CAMPAIGN_DATA_FAIL = "GET_CAMPAIGN_DATA_FAIL";

export const GET_FULL_CAMPAIGN_DATA_REQUEST = "GET_FULL_CAMPAIGN_DATA_REQUEST";
export const GET_FULL_CAMPAIGN_DATA_SUCCESS = "GET_FULL_CAMPAIGN_DATA_SUCCESS";
export const GET_FULL_CAMPAIGN_DATA_FAIL = "GET_FULL_CAMPAIGN_DATA_FAIL";
export const GET_FULL_CAMPAIGN_DATA_RESET = "GET_FULL_CAMPAIGN_DATA_RESET";

export const GET_CAMPAIGNCREATED_SCREENS_DATA_REQUEST =
  "GET_CAMPAIGNCREATED_SCREENS_DATA_REQUEST";
export const GET_CAMPAIGNCREATED_SCREENS_DATA_SUCCESS =
  "GET_CAMPAIGNCREATED_SCREENS_DATA_SUCCESS";
export const GET_CAMPAIGNCREATED_SCREENS_DATA_FAIL =
  "GET_CAMPAIGNCREATED_SCREENS_DATA_FAIL";

export const CAMPAIGN_STATUS_CHANGE_REQUEST = "CAMPAIGN_STATUS_CHANGE_REQUEST";
export const CAMPAIGN_STATUS_CHANGE_SUCCESS = "CAMPAIGN_STATUS_CHANGE_SUCCESS";
export const CAMPAIGN_STATUS_CHANGE_FAIL = "CAMPAIGN_STATUS_CHANGE_FAIL";
export const CAMPAIGN_STATUS_CHANGE_RESET = "CAMPAIGN_STATUS_CHANGE_RESET";

export const EDIT_ALL_SUB_CAMPAIGNS_REQUEST = "EDIT_ALL_SUB_CAMPAIGNS_REQUEST";
export const EDIT_ALL_SUB_CAMPAIGNS_SUCCESS = "EDIT_ALL_SUB_CAMPAIGNS_SUCCESS";
export const EDIT_ALL_SUB_CAMPAIGNS_FAIL = "EDIT_ALL_SUB_CAMPAIGNS_FAIL";
export const EDIT_ALL_SUB_CAMPAIGNS_RESET = "EDIT_ALL_SUB_CAMPAIGNS_RESET";

export const CAMPAIGN_CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_REQUEST =
  "CAMPAIGN_CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_REQUEST";
export const CAMPAIGN_CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_SUCCESS =
  "CAMPAIGN_CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_SUCCESS";
export const CAMPAIGN_CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_FAIL =
  "CAMPAIGN_CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_FAIL";
export const CAMPAIGN_CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_RESET =
  "CAMPAIGN_CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_RESET";

// status constant

export const CAMPAIGN_STATUS_PENDING = "Pending"; // plea not accepted
export const CAMPAIGN_STATUS_ACTIVE = "Active"; // plea accepted || direct created campaign by screen owner || after getting access from screen owner
export const CAMPAIGN_STATUS_DELETED = "Deleted"; // deleetd by Ally or brand || enddate >= current date
export const CAMPAIGN_STATUS_PAUSE = "Pause"; // pause by screen owner
export const CAMPAIGN_STATUS_REJECTED = "Rejected"; // pause by screen owner
export const CAMPAIGN_STATUS_COMPLETED = "Completed"; // when campaign.remainingSlots  = 0
export const CAMPAIGN_STATUS_HOLD = "Hold";

export const PENDING = "pending";
export const ACCEPTED = "accepted";
export const REJECTED = "rejected";
export const BUDGET = "budget";
export const FINAL = "final";
export const SCREEN = "screen";
export const PRIMARY_CAMPAIGN_MANAGER = "PrimaryCampaignManager";
export const SECONDARY_CAMPAIGN_MANAGER = "SecondaryCampaignManager";
export const PRIMARY_SCREEN_OWNER = "PrimaryScreenOwner";
export const CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_SENT = "PleaRequestBudgetSent";
export const CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_ACCEPTED =
  "PleaRequestBudgetAccepted";
export const CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_REJECTED =
  "PleaRequestBudgetRejected";
export const CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_SENT =
  "PleaRequestScreenApprovalSent";
export const CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_ACCEPTED =
  "PleaRequestScreenApprovalAccepted";
export const CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_REJECTED =
  "PleaRequestScreenApprovalRejected";
export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_SENT =
  "PleaRequestFinalApprovalSent";
export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_ACCEPTED =
  "PleaRequestFinalApprovalAccepted";
export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_REJECTED =
  "PleaRequestFinalApprovalRejected";

export const CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_SENT =
  "PleaRequestVendorBudgetApprovalSent";
export const CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_ACCEPTED =
  "PleaRequestVendorBudgetApprovalAccepted";
export const CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_REJECTED =
  "PleaRequestVendorBudgetApprovalRejected";

export const CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_SENT =
  "PleaRequestCreativeApprovalSent";
export const CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_ACCEPTED =
  "PleaRequestCreativeApprovalAccepted";
export const CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_REJECTED =
  "PleaRequestCreativeApprovalRejected";

export const BUDGET_PLEA = "BudgetPlea";
export const SCREEN_PLEA = "ScreenPlea";
export const FINAL_PLEA = "FinalPlea";

// Logs

export const GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_REQUEST =
  "GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_REQUEST";
export const GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_SUCCESS =
  "GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_SUCCESS";
export const GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_FAIL =
  "GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_FAIL";
export const GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_RESET =
  "GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_RESET";

export const APPROVE_CAMPAIGN_BUDGET_SCREEN_VENDOR_REQUEST =
  "APPROVE_CAMPAIGN_BUDGET_SCREEN_VENDOR_REQUEST";
export const APPROVE_CAMPAIGN_BUDGET_SCREEN_VENDOR_SUCCESS =
  "APPROVE_CAMPAIGN_BUDGET_SCREEN_VENDOR_SUCCESS";
export const APPROVE_CAMPAIGN_BUDGET_SCREEN_VENDOR_FAIL =
  "APPROVE_CAMPAIGN_BUDGET_SCREEN_VENDOR_FAIL";
export const APPROVE_CAMPAIGN_BUDGET_SCREEN_VENDOR_RESET =
  "APPROVE_CAMPAIGN_BUDGET_SCREEN_VENDOR_RESET";

export const APPROVE_CAMPAIGN_CREATIVE_SCREEN_VENDOR_REQUEST =
  "APPROVE_CAMPAIGN_CREATIVE_SCREEN_VENDOR_REQUEST";
export const APPROVE_CAMPAIGN_CREATIVE_SCREEN_VENDOR_SUCCESS =
  "APPROVE_CAMPAIGN_CREATIVE_SCREEN_VENDOR_SUCCESS";
export const APPROVE_CAMPAIGN_CREATIVE_SCREEN_VENDOR_FAIL =
  "APPROVE_CAMPAIGN_CREATIVE_SCREEN_VENDOR_FAIL";
export const APPROVE_CAMPAIGN_CREATIVE_SCREEN_VENDOR_RESET =
  "APPROVE_CAMPAIGN_CREATIVE_SCREEN_VENDOR_RESET";

export const GET_CAMPAIGN_REQUEST_BUDGET_DETAILS_FOR_SCREEN_VENDOR_REQUEST =
  "GET_CAMPAIGN_REQUEST_BUDGET_DETAILS_FOR_SCREEN_VENDOR_REQUEST";
export const GET_CAMPAIGN_REQUEST_BUDGET_DETAILS_FOR_SCREEN_VENDOR_SUCCESS =
  "GET_CAMPAIGN_REQUEST_BUDGET_DETAILS_FOR_SCREEN_VENDOR_SUCCESS";
export const GET_CAMPAIGN_REQUEST_BUDGET_DETAILS_FOR_SCREEN_VENDOR_ERROR =
  "GET_CAMPAIGN_REQUEST_BUDGET_DETAILS_FOR_SCREEN_VENDOR_ERROR";
export const GET_CAMPAIGN_REQUEST_BUDGET_DETAILS_FOR_SCREEN_VENDOR_RESET =
  "GET_CAMPAIGN_REQUEST_BUDGET_DETAILS_FOR_SCREEN_VENDOR_RESET";

export const GET_CAMPAIGN_REQUEST_CREATIVE_DETAILS_FOR_SCREEN_VENDOR_REQUEST =
  "GET_CAMPAIGN_REQUEST_CREATIVE_DETAILS_FOR_SCREEN_VENDOR_REQUEST";
export const GET_CAMPAIGN_REQUEST_CREATIVE_DETAILS_FOR_SCREEN_VENDOR_SUCCESS =
  "GET_CAMPAIGN_REQUEST_CREATIVE_DETAILS_FOR_SCREEN_VENDOR_SUCCESS";
export const GET_CAMPAIGN_REQUEST_CREATIVE_DETAILS_FOR_SCREEN_VENDOR_ERROR =
  "GET_CAMPAIGN_REQUEST_CREATIVE_DETAILS_FOR_SCREEN_VENDOR_ERROR";
export const GET_CAMPAIGN_REQUEST_CREATIVE_DETAILS_FOR_SCREEN_VENDOR_RESET =
  "GET_CAMPAIGN_REQUEST_CREATIVE_DETAILS_FOR_SCREEN_VENDOR_RESET";

export const GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_REQUEST =
  "GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_REQUEST";
export const GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_SUCCESS =
  "GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_SUCCESS";
export const GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_ERROR =
  "GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_ERROR";
export const GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_RESET =
  "GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_RESET";

export const CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_REQUEST =
  "CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_REQUEST";
export const CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_SUCCESS =
  "CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_SUCCESS";
export const CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_ERROR =
  "CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_ERROR";
export const CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_RESET =
  "CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_RESET";

export const CAMPAIGN_LOGS_REQUEST = "CAMPAIGN_LOGS_REQUEST";
export const CAMPAIGN_LOGS_SUCCESS = "CAMPAIGN_LOGS_SUCCESS";
export const CAMPAIGN_LOGS_FAIL = "CAMPAIGN_LOGS_FAIL";

export const CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_REQUEST =
  "CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_REQUEST";
export const CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_SUCCESS =
  "CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_SUCCESS";
export const CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_ERROR =
  "CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_ERROR";
export const CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_RESET =
  "CONVERT_CREATIVES_TO_RESPECTIVE_BITRATE_RESET";

export const CAMPAIGN_PLAN_TYPE_REGULAR = "Regular";
export const CAMPAIGN_PLAN_TYPE_TOPICAL = "Topical";
export const CAMPAIGN_PLAN_TYPE_TRIGGER = "Trigger";
export const CAMPAIGN_PLAN_TYPE_STORE = "Store";
export const CAMPAIGN_PLAN_TYPE_KNOW = "IKnowItAll";

// sov constants
export const CONTINUOUS_SOV = "continuous";
export const ORDERED_SOV = "ordered";
export const RANDOM_SOV = "random";
export const SOV_TYPE_ARRAY = [
  "Select SOV Type",
  "ordered",
  "continuous",
  "random",
];
